import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "ss_cookie_consent";

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  useEffect(() => {
    const reopen = () => setShow(true);
    window.addEventListener("open-cookie-settings", reopen);
    return () => window.removeEventListener("open-cookie-settings", reopen);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-[80]"
          data-testid="cookie-consent-banner"
        >
          <div className="bg-white border border-stylist-border rounded-2xl shadow-2xl p-5">
            <div className="flex items-start gap-3">
              <span className="w-10 h-10 rounded-full bg-stylist-gold/15 flex items-center justify-center shrink-0">
                <Cookie className="w-5 h-5 text-stylist-gold" />
              </span>
              <div>
                <p className="font-serif text-xl text-stylist-ink leading-tight">We value your privacy</p>
                <p className="mt-1 text-sm text-stylist-ink2 leading-relaxed">
                  We use strictly necessary cookies to run the site and, with your consent, analytics
                  cookies to improve it. Read our{" "}
                  <Link to="/legal/cookies" className="text-stylist-gold underline">
                    Cookies Policy
                  </Link>
                  .
                </p>
              </div>
            </div>
            <div className="mt-4 flex flex-col sm:flex-row gap-2">
              <button
                onClick={() => choose("rejected")}
                data-testid="cookie-reject-button"
                className="flex-1 rounded-full border border-stylist-border px-5 py-2.5 text-sm text-stylist-ink hover:bg-stylist-bg2 transition-colors"
              >
                Reject all
              </button>
              <button
                onClick={() => choose("accepted")}
                data-testid="cookie-accept-button"
                className="flex-1 rounded-full bg-stylist-ink text-white px-5 py-2.5 text-sm hover:bg-stylist-gold transition-colors"
              >
                Accept all
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
